import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Text } from '@actual-app/components/text';

import { PRODUCT_NAME } from '#product-brand';

import { Setting } from './UI';

export function Backups() {
  const { t } = useTranslation();
  const BACKUP_FREQUENCY_MINS = 15;
  const MAX_BACKUPS = 10;

  return (
    <Setting>
      <Text>
        <strong>
          <Trans>Backups</Trans>
        </strong>
        <p>
          {t(
            'Backups are taken every {{BACKUP_FREQUENCY_MINS}} minutes and stored in',
            { BACKUP_FREQUENCY_MINS },
          )}{' '}
          <strong>
            <i>
              {t("{{productName}}'s data directory", {
                productName: PRODUCT_NAME,
              })}
            </i>
          </strong>
          .{' '}
          {t(
            '{{productName}} retains a maximum of {{MAX_BACKUPS}} backups at any time.',
            { productName: PRODUCT_NAME, MAX_BACKUPS },
          )}
        </p>
      </Text>
    </Setting>
  );
}
